import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Import css files for react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Components
import TestimonialBox from "../Elements/TestimonialBox";

export default function TestimonialSlider({ extra3 }) {
  const items = extra3?.carousel || [];

  if (items.length === 1) {
    // Single item, no slider
    const item = items[0];
    return (
      <SingleWrapper className="flexCenter">
        <TestimonialBox text={item.content} author={item.name} />
      </SingleWrapper>
    );
  }

  if (items.length === 2) {
    // Two items, show without infinite loop, no duplication
    const settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
      ],
    };

    return (
      <div>
        <Slider {...settings}>
          {items.map((item) => (
            <LogoWrapper key={item._id} className="flexCenter">
              <TestimonialBox text={item.content} author={item.name} />
            </LogoWrapper>
          ))}
        </Slider>
      </div>
    );
  }

  if (items.length >= 3) {
    // 3 or more items, infinite loop and duplicate for smooth looping
    const loopItems = [...items, ...items];
    const settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
      ],
    };

    return (
      <div>
        <Slider {...settings}>
          {loopItems.map((item, index) => (
            <LogoWrapper key={`${item._id}-${index}`} className="flexCenter">
              <TestimonialBox text={item.content} author={item.name} />
            </LogoWrapper>
          ))}
        </Slider>
      </div>
    );
  }

  // fallback if no items
  return null;
}

const LogoWrapper = styled.div`
  width: 90%;
  padding: 0 5%;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;

const SingleWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 0 5%;
`;
